import { matchPath, useLocation } from 'react-router-dom'

import { PanelStore, UserStore } from 'stores'
import { getRoute } from 'utils/routes'

import type { IWinninAuthRouterPermissionsModelReturn } from './winnin-auth-router-permissions.types'
import { getUserRouterPermissions } from '../common/winnin-auth-permissions.utils'

export const useWinninAuthRouterPermissionsModel = (): IWinninAuthRouterPermissionsModelReturn => {
  const location = useLocation()

  const permissions = getUserRouterPermissions(UserStore.getActiveWorkspaceModules)

  if (!permissions) {
    return { shouldRedirect: false, redirectTo: '' }
  }

  const isAllowed = permissions.routes.some(route => Boolean(matchPath(location.pathname, { path: route })))

  if (isAllowed) {
    return { shouldRedirect: false, redirectTo: '' }
  }

  const currentPanelId = Object(PanelStore?.selectedPanel)?.panelId || UserStore.urlParams?.panelId

  if (!currentPanelId) {
    return { shouldRedirect: false, redirectTo: '' }
  }

  const redirectTo = getRoute(permissions.default, { panelId: currentPanelId })

  return { shouldRedirect: true, redirectTo }
}
